import { HelpPage } from './help.page';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { HelpPageRoutingModule } from './help-routing.module';
import { SharedModule } from '../shared-module/shared.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    SharedModule,
    CommonModule,
    HelpPageRoutingModule
  ],
  declarations: [HelpPage]
})
export class HelpPageModule {}
